var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discussion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.517,
    height: 55.5,
    viewBox: "0 0 53.517 55.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47263",
    "data-name": "Group 47263",
    transform: "translate(15.516 25.215)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2751",
    "data-name": "Ellipse 2751",
    cx: 6.076,
    cy: 6.076,
    rx: 6.076,
    ry: 6.076,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 3.443, 11.423)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54444",
    "data-name": "Path 54444",
    d: "M178.415,378.05a11.243,11.243,0,0,0-22.485,0Z",
    transform: "translate(-155.93 -351.823)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47264",
    "data-name": "Group 47264",
    transform: "translate(31.061 30.093)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2752",
    "data-name": "Ellipse 2752",
    cx: 6.076,
    cy: 6.076,
    rx: 6.076,
    ry: 6.076,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 4.248, 1.944)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54445",
    "data-name": "Path 54445",
    d: "M316.751,413.581a11.243,11.243,0,0,0-22.454,0,.562.562,0,0,0,.561.591H316.19a.562.562,0,0,0,.561-.591Z",
    transform: "translate(-294.296 -388.766)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47265",
    "data-name": "Group 47265",
    transform: "translate(0 28.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2753",
    "data-name": "Ellipse 2753",
    cx: 6.076,
    cy: 6.076,
    rx: 6.076,
    ry: 6.076,
    transform: "translate(2.819 10.147) rotate(-56.58)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54446",
    "data-name": "Path 54446",
    d: "M40.28,413.581a11.243,11.243,0,0,0-22.454,0,.562.562,0,0,0,.561.591H39.719a.562.562,0,0,0,.561-.591Z",
    transform: "translate(-17.825 -387.326)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47266",
    "data-name": "Group 47266",
    transform: "translate(8.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54447",
    "data-name": "Path 54447",
    d: "M229.717,53.5h-20.4a1.564,1.564,0,0,0-1.561,1.561V67.84a1.564,1.564,0,0,0,1.561,1.561h11.6l6.609,4.745V69.4h2.188a1.564,1.564,0,0,0,1.561-1.561V55.06a1.564,1.564,0,0,0-1.561-1.561Z",
    transform: "translate(-195.082 -48.5)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54448",
    "data-name": "Path 54448",
    d: "M96.475,82.444h20.4A1.564,1.564,0,0,1,118.432,84v12.78a1.564,1.564,0,0,1-1.561,1.561h-11.6l-6.609,4.745V98.346H96.475a1.564,1.564,0,0,1-1.561-1.561V84A1.564,1.564,0,0,1,96.475,82.444Z",
    transform: "translate(-94.914 -74.193)",
    fill: "#72d561",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54449",
    "data-name": "Path 54449",
    d: "M134.411,9h20.4a1.564,1.564,0,0,1,1.561,1.561v12.78a1.564,1.564,0,0,1-1.561,1.561h-11.6L136.6,29.648V24.9h-2.188a1.564,1.564,0,0,1-1.561-1.561V10.561A1.564,1.564,0,0,1,134.411,9Z",
    transform: "translate(-128.588 -9)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54450",
    "data-name": "Path 54450",
    d: "M167.182,42.156a.9.9,0,1,1,0-1.8H181.39a.9.9,0,0,1,0,1.8Zm0,3.976a.9.9,0,1,1,0-1.8H181.39a.9.9,0,0,1,0,1.8Zm0-7.952a.9.9,0,1,1,0-1.8H181.39a.9.9,0,0,1,0,1.8Z",
    transform: "translate(-158.265 -33.307)",
    fill: "#eff4f7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsPending);
export default __webpack_public_path__ + "static/media/applications-pending.c98a7fabae01a8802a054e840fdf57f1.svg";
export { ForwardRef as ReactComponent };